import { create } from 'zustand';

type AppId = 'ext' | 'web';

type State = {
  appId?: AppId;
  isExt?: boolean;
  isWeb?: boolean;
};

type Actions = {
  setAppId: (appId: AppId) => void;
};

type AppStore = State & Actions;

export const useAppStore = create<AppStore>(set => {
  return {
    appId: 'web',
    isExt: false,
    isWeb: true,

    setAppId: (appId: AppId) => {
      if (appId === 'ext') {
        set({ appId, isExt: true, isWeb: false });
      }

      if (appId === 'web') {
        set({ appId, isExt: false, isWeb: true });
      }
    }
  };
});
